export default {
  scenes: {
    morningLight: {
      beats: {
        beforeTheStorm: {
          events: [
            {
              type: 'showLocation',
              locationId: 'weddingVenue'
            },
            {
              type: 'showEffect',
              effect: 'overlay',
              overlayType: 'lightOverlay',
              opacity: 0.3
            },
            {
              type: 'showNarration',
              text: 'Dawn breaks on the wedding day. Isabelle arrives early at the venue, her heart heavy with the weight of last night\'s events. The morning light streams through the stained glass windows, casting colorful shadows on the empty pews.'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'thinking',
              text: 'Flowers, check. Music, check. Just keep moving. Don\'t think.',
              choices: [
                {
                  text: 'Focus on Work',
                  next: {
                    scene: 'morningLight',
                    beat: 'theProfessional'
                  }
                },
                {
                  text: 'Confront the Reality',
                  next: {
                    scene: 'morningLight',
                    beat: 'theDreamer'
                  }
                }
              ]
            },
            {
              type: 'hideEffect',
              effect: 'overlay',
              overlayType: 'lightOverlay'
            }
          ]
        },
        theProfessional: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'emily',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'isabelle',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'emily',
              variation: 'happy',
              text: 'Isabelle! Isn\'t it a perfect morning?'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'emily',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Everything\'s ready, Emily. You\'ll have your dream wedding.'
            },
            {
              type: 'showNarration',
              text: 'Isabelle maintains her composure as the venue begins to fill with wedding staff and early arrivals.'
            },
            {
              type: 'showCharacter',
              characterId: 'emily',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'isabelle',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'emily',
              variation: 'neutral',
              text: 'Daniel seemed quiet this morning. Do you think he\'s just nervous?'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'emily',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'All grooms are nervous on their wedding day.'
            },
            {
              type: 'showCharacter',
              characterId: 'emily',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'emilysMother',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'hideCharacter',
              characterId: 'isabelle',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'emilysMother',
              variation: 'neutral',
              text: 'It\'s perfectly normal, dear.'
            }
          ],
          next: {
            scene: 'finalPreparations',
            beat: 'theLastHour'
          }
        },
        theDreamer: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'thinking',
              text: 'After last night, nothing feels real anymore.'
            },
            {
              type: 'showCharacter',
              characterId: 'emily',
              variation: 'surprised',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'isabelle',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'emily',
              variation: 'surprised',
              text: 'Oh! You\'re here so early!'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'emily',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Just making sure everything\'s perfect for your big day.'
            }
          ],
          next: {
            scene: 'finalPreparations',
            beat: 'theLastHour'
          }
        }
      }
    },
    finalPreparations: {
      beats: {
        theLastHour: {
          events: [
            {
              type: 'showLocation',
              locationId: 'gardenTerrace'
            },
            {
              type: 'showNarration',
              text: 'As guests begin to arrive, Isabelle catches sight of Daniel alone in the church garden.'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'thinking',
              text: 'What should I do?',
              choices: [
                {
                  text: 'Maintain Distance',
                  next: {
                    scene: 'finalPreparations',
                    beat: 'theFinalWall'
                  }
                },
                {
                  text: 'One Last Moment',
                  next: {
                    scene: 'finalPreparations',
                    beat: 'theLastChance'
                  }
                }
              ]
            }
          ]
        },
        theFinalWall: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Not now. Not ever.'
            },
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'isabelle',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'neutral',
              text: 'Isabelle, wait-'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'daniel',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'The ceremony starts in twenty minutes, Mr. Whitmore. You should be inside.'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Time to do my job.'
            },
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'isabelle',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'neutral',
              text: 'Always the perfect professional...'
            }
          ],
          next: {
            scene: 'theCeremonyBegins',
            beat: 'thePointOfNoReturn'
          }
        },
        theLastChance: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'You should be getting ready.'
            },
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'isabelle',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'crying',
              text: 'Tell me what to do, Isabelle. Please.'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'crying',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'daniel',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'crying',
              text: 'I can\'t make this choice for you.'
            }
          ],
          next: {
            scene: 'theCeremonyBegins',
            beat: 'thePointOfNoReturn'
          }
        }
      }
    },
    theCeremonyBegins: {
      beats: {
        thePointOfNoReturn: {
          events: [
            {
              type: 'showLocation',
              locationId: 'weddingVenue'
            },
            {
              type: 'showNarration',
              text: 'The wedding march begins to play. Emily waits at the back of the church. Daniel stands at the altar.'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'thinking',
              text: 'What should I do in this final moment?',
              choices: [
                {
                  text: 'Stay Silent Forever',
                  next: {
                    scene: 'theCeremonyBegins',
                    beat: 'staySilent'
                  }
                },
                {
                  text: 'Leave Before the Vows',
                  next: {
                    scene: 'theCeremonyBegins',
                    beat: 'leaveBeforeVows'
                  }
                },
                {
                  text: 'Stop the Wedding',
                  next: {
                    scene: 'theCeremonyBegins',
                    beat: 'stopWedding'
                  }
                }
              ]
            }
          ]
        },
        staySilent: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'thinking',
              text: 'Sometimes love means letting go.'
            },
            {
              type: 'showCharacter',
              characterId: 'minister',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'isabelle',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'minister',
              variation: 'neutral',
              text: 'If anyone knows why these two should not be wed...'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'minister',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Goodbye, Daniel.'
            }
          ],
          goToChapter: {
            chapter: 'chapter6'
          }
        },
        leaveBeforeVows: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'thinking',
              text: 'I can\'t watch this.'
            },
            {
              type: 'showCharacter',
              characterId: 'assistant',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'isabelle',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'assistant',
              variation: 'neutral',
              text: 'Ms. Carter?'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'assistant',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Handle the rest. I have to go.'
            }
          ],
          goToChapter: {
            chapter: 'chapter6'
          }
        },
        stopWedding: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'thinking',
              text: 'I can\'t let this happen.'
            },
            {
              type: 'showCharacter',
              characterId: 'minister',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'isabelle',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'minister',
              variation: 'neutral',
              text: 'Speak now or forever hold your peace...'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'minister',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Wait!'
            }
          ],
          goToChapter: {
            chapter: 'chapter6'
          }
        }
      }
    }
  }
}
